import React from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import "../modal.css";
import html2pdf from "html2pdf.js";
import jiviniLogo from "../../../assets/jivinilogo.png";
import PdfCurrentOrdersTableData from "../../tables/pdfCurrentOrdersTableData";

const CurrentOrdersPdfView = ({ id, show, orderDetailData, handleClose }) => {
  const data = [
    {
      title: "Order ID",
      content: orderDetailData?.order_id,
    },
    {
      title: "Company Name",
      content: orderDetailData?.vendor?.name,
    },
    {
      title: "Division",
      content: orderDetailData?.vendorDivision?.name,
    },
    // {
    //   title: "Value Of Order",
    //   content: `₹ ${orderDetailData?.total}`,
    // },
    // {
    //   title: "Reimbursement Status",
    //   content: "---",
    // },
    {
      title: "Doctor Name",
      content: orderDetailData?.doctor?.name ?? "- -",
    },
    {
      title: "Pharmacy Name",
      content: orderDetailData?.pharmacy_id
        ? orderDetailData?.pharmacy?.pharmacy_name
        : orderDetailData?.doctor?.pharmacy_type == "attach"
          ? orderDetailData?.doctor?.doctorAttachPharmacy?.pharmacy?.pharmacy_name
          : orderDetailData?.doctor?.pharmacy_type == "self"
            ? orderDetailData?.doctor?.doctorSelfPharmacy?.pharmacy_name
            : orderDetailData?.doctor?.pharmacy_type == "dispensing" &&
            "Dispensing",
    },
    {
      title: "Mobile Number",
      content: orderDetailData?.doctor ? orderDetailData?.doctor?.mobile : orderDetailData?.pharmacy?.mobile,
    },
  ];

  const data2 = [
    // {
    //   title: "Alternate Mobile Number",
    //   content: orderDetailData?.doctor ? orderDetailData?.doctor?.alternate_mobile : orderDetailData?.pharmacy?.alternate_mobile,
    // },
    // {
    //   title: "Email Address",
    //   content: orderDetailData?.doctor ? orderDetailData?.doctor?.email : orderDetailData?.pharmacy?.email,
    // },
    {
      title: "Address",
      content: orderDetailData?.doctor ?
        `${orderDetailData?.doctor?.address?.address_one}, ${orderDetailData?.doctor?.address?.address_two}, ${orderDetailData?.doctor?.address?.address_three}`
        : `${orderDetailData?.pharmacy?.address?.address_one}, ${orderDetailData?.pharmacy?.address?.address_two}, ${orderDetailData?.pharmacy?.address?.address_three}`,
    },
    {
      title: "Landmark",
      content: orderDetailData?.doctor ? orderDetailData?.doctor?.address?.landmark : orderDetailData?.pharmacy?.address?.landmark,
    },
    {
      title: "Concerned FF Name",
      content: orderDetailData?.orderHeirarchy?.fieldForceUser?.name,
    },
    {
      title: "Concerned FF Mobile Number",
      content: orderDetailData?.orderHeirarchy?.fieldForceUser?.mobile,
    },
    {
      title: "Concerned CFA Name",
      content: orderDetailData?.concernedCfa?.cfa_name,
    },
    {
      title: "Concerned CFA Mobile Number",
      content: orderDetailData?.concernedCfa?.mobile,
    },
  ];

  const exportToPdf = () => {
    const toRender = document.getElementById("toRender");
    const options = {
      margin: [30, 10],
      filename: "orders.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(toRender).save();
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="current-orders-view-container col-10 mx-auto px-3"
      >
        <ModalHeader>
          <div className=" d-flex justify-content-between w-100 ">
            <div>
              <span className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-0">
                {orderDetailData?.order_id} - View
              </span>
            </div>
            <div className="d-flex justify-content-end  gap-2">
              <div className="mt-1">
                <button
                  type="button"
                  onClick={() => {
                    exportToPdf();
                  }}
                  className="modal-submit-btn text-white px-4 py-2 fs_12"
                >
                  print
                </button>
              </div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="w-100 h-100">
          <div
            className="w-100"
            style={{ overflowY: "scroll", height: "40rem" }}
          >
            <div id="toRender" className="mx-2">
              <div className="my-2 mb-4">
                <img src={jiviniLogo} />
              </div>
              <div className="d-flex ">
                <div className="col-6 col-lg-6">
                  {data.map((items, index) => (
                    <div className="d-flex gap-" key={index}>
                      <div className="col-6 col-sm-5">
                        <span className="fs_12">
                          {items.title}
                        </span>
                      </div>
                      <span className="fs_12 ms-3">{items.content}</span>
                    </div>
                  ))}
                </div>
                <div className="col-6">
                  {data2.map((items, index) => (
                    <div className="d-flex gap-" key={index}>
                      <div className="col-6 col-sm-5">
                        <span className="fs_12">
                          {items.title}
                        </span>
                      </div>
                      <span className="fs_12 ms-3 col-6">{items.content}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-3">
                <p className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-2 label-text">
                  Order Details - {orderDetailData?.order_id}
                </p>
                <div className="mt-3">
                  <PdfCurrentOrdersTableData
                    orderProducts={orderDetailData?.orderProducts}
                    total={orderDetailData?.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CurrentOrdersPdfView;
